import { dismissAlert } from '@calendly/alert'
import { createSlice } from '@reduxjs/toolkit'

import changeSet from 'core/change_set'
import { reducerRegistry } from 'reducer-registry'

const initialState = {
  isETEditorSidePanelOpen: false,
  eventTypePreviewData: null,
  membersPreviewData: null
}

const slice = createSlice({
  name: 'eventTypeEditor',
  initialState,
  reducers: {
    resetState: () => initialState,
    setIsETEditorSidePanelOpen: (state, { payload }) => {
      state.isETEditorSidePanelOpen = payload
    },
    updateEventTypePreviewData: (state, { payload }) => {
      const { eventType, members } = payload
      state.eventTypePreviewData = eventType
      state.membersPreviewData = members
    }
  }
})

reducerRegistry.add('eventTypeEditor', slice.reducer)

export const {
  actions: {
    setIsETEditorSidePanelOpen,
    updateEventTypePreviewData
  }
} = slice

export const resetEventTypeEditorSidebar = ({ resetState = true, resetAlert = false } = {}) => async (dispatch) => {
  if (resetState) { dispatch(slice.actions.resetState()) }
  if (resetAlert) { dispatch(dismissAlert()) }
  changeSet.reset()
}

export const initializeEventTypeEditorSidebar = ({ resetState = true } = {}) => async (dispatch) => {
  if (resetState) { dispatch(slice.actions.resetState()) }
  changeSet.allowDirtyNavigation()
}
